<template>
  <h2 class="base-title base-title__title" v-if="title" v-bind="$attrs">
    <slot />
  </h2>
  <p class="base-title base-title__desciption" v-else v-bind="$attrs">
    <slot />
  </p>
</template>

<script>
export default {
  props: {
    title: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.base-title {
  font-family: "SF Pro Display";
  font-style: normal;
  color: #121131;

  &__title {
    font-weight: 600;
    font-size: 32px;
    line-height: 48px;
  }

  &__desciption {
    font-weight: 400;
    font-size: 18px;
    line-height: 28px;
    white-space: pre-line;
  }
}
</style>
